<script setup>
import { computed } from 'vue';
import WorkflowAddStepMenu from './WorkflowAddStepMenu.vue';

const props = defineProps({
  connectorId: { type: String, required: true },
  lineClass: { type: String, required: true },
  plusButtonClass: { type: String, default: '' },
  items: { type: Array, required: true },
});

const emit = defineEmits(['select']);

const activeAddMenuId = defineModel('activeAddMenuId', {
  type: String,
  default: null,
});

const showAddButton = computed(
  () => !activeAddMenuId.value || activeAddMenuId.value === props.connectorId
);

const onMenuOpen = () => {
  activeAddMenuId.value = props.connectorId;
};

const onMenuClose = () => {
  if (activeAddMenuId.value === props.connectorId) {
    activeAddMenuId.value = null;
  }
};

const lineBarClass = 'w-0.5 shrink-0 min-h-4';
</script>

<template>
  <div class="flex h-[4.5rem] w-full shrink-0 flex-col items-center">
    <div class="flex-1" :class="[lineBarClass, lineClass]" aria-hidden="true" />

    <div class="relative z-10 flex shrink-0 items-center justify-center py-0.5">
      <span
        class="pointer-events-none absolute size-7 rounded-full bg-[radial-gradient(rgb(235_240_245)_1.2px,transparent_0)] bg-[length:16px_16px] dark:bg-[radial-gradient(rgb(41_63_81)_1.2px,transparent_0)]"
        aria-hidden="true"
      />
      <WorkflowAddStepMenu
        v-if="showAddButton"
        :items="items"
        :plus-button-class="plusButtonClass"
        @select="emit('select', $event)"
        @open="onMenuOpen"
        @close="onMenuClose"
      />
      <span v-else class="size-[22px]" aria-hidden="true" />
    </div>

    <div class="flex-1" :class="[lineBarClass, lineClass]" aria-hidden="true" />
  </div>
</template>
